module.exports = __webpack_public_path__ + "7a4dba18cc3055f6fc2ae032df984aee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-donut.png
// module id = 1890
// module chunks = 0